// Control inline para marcar el estado del telefono de un cliente.
// Renderiza un badge con el estado actual (si es invalido) + boton
// para cambiar estado.
//
// Uso:
//   <TelefonoEstadoControl cliente={cliente} onCambio={(estado, motivo) => ...} />

import { useState, useEffect, useRef } from "react";
import {
  TELEFONO_ESTADOS,
  getEstadoTelefono,
  esTelefonoInvalido,
  getLabelEstado,
} from "../../services/telefonoService";
import "./TelefonoEstadoControl.css";

export default function TelefonoEstadoControl({ cliente, onCambio }) {
  const [abierto, setAbierto] = useState(false);
  const [motivoTmp, setMotivoTmp] = useState("");
  const [estadoTmp, setEstadoTmp] = useState("");
  const ref = useRef(null);

  const estado = getEstadoTelefono(cliente);
  const invalido = esTelefonoInvalido(cliente);
  const meta = TELEFONO_ESTADOS.find((e) => e.value === estado);

  // Cerrar al hacer click afuera
  useEffect(() => {
    function onClickFuera(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setAbierto(false);
        setEstadoTmp("");
        setMotivoTmp("");
      }
    }
    if (abierto) document.addEventListener("mousedown", onClickFuera);
    return () => document.removeEventListener("mousedown", onClickFuera);
  }, [abierto]);

  function handleSeleccionarEstado(nuevoEstado) {
    // Si el nuevo estado es "valido" no requerimos motivo (es restauracion)
    if (nuevoEstado === "valido") {
      onCambio?.("valido", "");
      setAbierto(false);
      return;
    }
    // Sino, pedimos motivo opcional inline
    setEstadoTmp(nuevoEstado);
  }

  function handleConfirmar() {
    if (!estadoTmp) return;
    onCambio?.(estadoTmp, motivoTmp.trim());
    setAbierto(false);
    setEstadoTmp("");
    setMotivoTmp("");
  }

  function handleCancelar() {
    setEstadoTmp("");
    setMotivoTmp("");
  }

  return (
    <span className="tel-estado-wrap" ref={ref}>
      {invalido && (
        <span
          className="tel-estado-badge"
          style={{ background: meta?.color || "#dc2626" }}
          title={cliente?.telefonoEstadoMotivo || ""}
        >
          {getLabelEstado(estado)}
        </span>
      )}
      <button
        type="button"
        className="tel-estado-btn"
        onClick={() => setAbierto((v) => !v)}
      >
        {invalido ? "Cambiar" : "Marcar inválido"} ▾
      </button>

      {abierto && (
        <div className="tel-estado-pop">
          {!estadoTmp ? (
            <>
              <div className="tel-estado-pop-title">Selecciona estado:</div>
              {TELEFONO_ESTADOS.filter((e) => e.value !== estado).map((e) => (
                <button
                  key={e.value}
                  type="button"
                  className="tel-estado-pop-item"
                  onClick={() => handleSeleccionarEstado(e.value)}
                >
                  <span
                    className="tel-estado-dot"
                    style={{ background: e.color }}
                  />
                  {e.label}
                </button>
              ))}
            </>
          ) : (
            <>
              <div className="tel-estado-pop-title">
                Marcar como <strong>{getLabelEstado(estadoTmp)}</strong>
              </div>
              <textarea
                className="tel-estado-pop-motivo"
                placeholder="Motivo / detalle (opcional)"
                value={motivoTmp}
                onChange={(e) => setMotivoTmp(e.target.value)}
                rows={2}
                autoFocus
              />
              <div className="tel-estado-pop-actions">
                <button
                  type="button"
                  className="tel-estado-btn-cancel"
                  onClick={handleCancelar}
                >
                  Atrás
                </button>
                <button
                  type="button"
                  className="tel-estado-btn-confirm"
                  onClick={handleConfirmar}
                >
                  Confirmar
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </span>
  );
}
